// Slider config moved to: assets/js/components/ui-components/slick-slider.js (preset "our-team-picture")
// Template updated: templates/public/static/our-team/main.html.twig
//   (data-lazy-init="slick-slider" data-slick-preset="our-team-picture" on .ot-hero_picture and .ot-culture_picture)

export default class OurTeamPage {
	constructor() {
		this.tabItems = $(".js-team-tab-switch-item");
		this.tabPanels = $(".team--tab-item");
		this.mobileWidth = 768;
	}

	init() {
		if (!this.tabItems.length) return;

		this.setInitialAriaStates();
		this.handleEvents();

		// Activate the initial tab (usually "all")
		const $activeTab = this.tabItems.filter(".active").first();
		if ($activeTab.length) {
			this.activateTab($activeTab);
		} else {
			this.activateTab(this.tabItems.first());
		}
	}

	// --- Set ARIA attributes on init ---
	setInitialAriaStates() {
		this.tabItems.each((_, el) => {
			const $tab = $(el);
			const isActive = $tab.hasClass("active");
			$tab.attr({
				role: "tab",
				tabindex: isActive ? "0" : "-1",
				"aria-selected": isActive ? "true" : "false"
			});
		});

		this.tabPanels.each((_, el) => {
			const $panel = $(el);
			const isVisible = $panel.hasClass("in");
			$panel.attr({
				role: "tabpanel",
				hidden: !isVisible
			});
		});
	}

	// --- Activate a tab + show its content ---
	activateTab($tab) {
		const tabId = $tab.data("tab");
		if (!tabId) return;

		// Update tabs
		this.tabItems.removeClass("active in")
			.attr({ "aria-selected": "false", tabindex: "-1" });

		$tab.addClass("active in")
			.attr({ "aria-selected": "true", tabindex: "0" })
			//.focus();

		// Update panels
		this.tabPanels.removeClass("in").attr("hidden", true);

		if (tabId === "all") {
			this.tabPanels.addClass("in").removeAttr("hidden");
		} else {
			const $panel = $(`#tab-${tabId}`);
			if ($panel.length) {
				$panel.addClass("in").removeAttr("hidden");
			}
		}
	}

	// --- Improved keyboard navigation ---
	handleKeyboardNav(e, $currentTab) {
		const key = e.key;
		const tabs = Array.from(this.tabItems); // get pure array of DOM elements
		const currentIndex = tabs.indexOf($currentTab[0]);
		let newIndex = currentIndex;

		switch (key) {
			case "ArrowLeft":
				newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
				break;
			case "ArrowRight":
				newIndex = (currentIndex + 1) % tabs.length;
				break;
			case "Home":
				newIndex = 0;
				break;
			case "End":
				newIndex = tabs.length - 1;
				break;
			case "Enter":
			case " ":
				e.preventDefault();
				this.activateTab($currentTab);
				return;
			default:
				return; // exit if not navigation key
		}

		e.preventDefault();
		const $nextTab = $(tabs[newIndex]);
		this.activateTab($nextTab);
	}

	// --- Events ---
	handleEvents() {
		this.tabItems.on("click", (event) => {
			event.preventDefault();
			this.activateTab($(event.currentTarget));
		});

		this.tabItems.on("keydown", (event) => {
			this.handleKeyboardNav(event, $(event.currentTarget));
		});

		// Reset to "All" on mobile
		$(window).on("resize", () => {
			const $tabAll = this.tabItems.filter('[data-tab="all"]');

			if (window.innerWidth <= this.mobileWidth) {
				this.tabPanels.addClass("in").removeAttr("hidden");
				this.tabItems.removeClass("active in")
					.attr({ "aria-selected": "false", "tabindex": "-1" });
				$tabAll.addClass("active in")
					.attr({ "aria-selected": "true", "tabindex": "0" });
			}
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const ourTeamPage = new OurTeamPage();
	ourTeamPage.init();
});
